/**
 * day-labels — dies i textos de la graella (`plans/calendar-visual-refresh.md` §5, F1). Funcions
 * pures, fora dels components perquè el Fast Refresh no se'n queixi i per provar-les soles.
 */

import { formatCalendarDate } from '@/lib/dates';

/** Cap de setmana del calendari (D5): divendres i dissabte, les nits fortes. */
export function isWeekendNight(date: Date): boolean {
  const day = date.getDay();
  return day === 5 || day === 6;
}

/** `YYYY-MM-DD` d'una data local. */
function toDateKey(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Data llarga en català per al `title` de la capçalera: «dissabte, 4 d’octubre». */
export function longDayTitle(date: Date): string {
  return formatCalendarDate(toDateKey(date), 'ca', "EEEE, d 'de' MMMM");
}

/** «29 set.» → «29 set» (dates curtes en català). */
function shortDay(iso: string): string {
  return formatCalendarDate(iso, 'ca', 'd MMM').replace(/\./g, '');
}

/** `title` de la franja d'una cancel·lada: «Cancel·lada: {nom} · {entrada}–{sortida}». */
export function cancelledStripTitle(reservation: {
  guestName: string;
  checkIn: string;
  checkOut: string;
}): string {
  return `Cancel·lada: ${reservation.guestName} · ${shortDay(reservation.checkIn)}–${shortDay(reservation.checkOut)}`;
}
